

export function currentToggleValue(subState, key, defaultValue=false) {
  if (typeof  subState[key] === "undefined") {
    return defaultValue;
  } else {
    return subState[key];
  }
}


export const PACKING_LATER_LIST_KEY = 'PACKING_LATER_LIST';
export const DELIVERY_TODO_LIST_KEY = 'DELIVERY_TODO_LIST';
export const DELIVERING_LIST_KEY = 'DELIVERING_LIST';
export const PACKING_NOW_LONG_LIST_KEY = 'PACKING_NOW_LONG_LIST';
export const NEXT_LIST_KEY = 'NEXT_LIST';
export const INCOMING_PLANNING_LIST_KEY = 'INCOMING_PLANNING_LIST';
export const PACKING_XD_TO_CHECK_KEY = 'PACKING_XD_TO_CHECK_LIST';
export const PACKING_XD_STAND_BY_KEY = 'PACKING_XD_STAND_BY';
export const EXTRA_COST_DEMAND_LIST_KEY = 'EXTRA_COST_DEMAND_LIST';
export const UBER_ORDERS_TO_REGULARIZE_KEY = 'UBER_ORDERS_TO_REGULARIZE';
// Toggle "Faire le point avec" : filtre le tableau Préparateurs pour ne
// garder que ceux avec is_comment_count_warning (cas à traiter côté back).
// Volontairement HORS de TOGGLE_KEYS : on veut un défaut natif à false sans
// persistance localStorage (le reducer switch_toggle initialise à true tout
// ce qui est listé dans TOGGLE_KEYS). À chaque rechargement de Flow, le
// filtre repart désactivé.
export const NEXTS_NEED_COMMENT_FILTER_KEY = 'NEXTS_NEED_COMMENT_FILTER';

export const TOGGLE_KEYS = [
  PACKING_LATER_LIST_KEY,
  NEXT_LIST_KEY,
  DELIVERING_LIST_KEY,
  DELIVERY_TODO_LIST_KEY,
  INCOMING_PLANNING_LIST_KEY,
  PACKING_NOW_LONG_LIST_KEY,
  PACKING_XD_TO_CHECK_KEY,
  PACKING_XD_STAND_BY_KEY,
  EXTRA_COST_DEMAND_LIST_KEY,
  UBER_ORDERS_TO_REGULARIZE_KEY,
];
